import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import TextElementStyled from './styled';
const TextElement = ({ textGradient, gradientBackground, noRem, children, ...props }) => (_jsx(TextElementStyled, { "$textGradient": textGradient, "$gradientBackground": gradientBackground, "$noRem": noRem, ...props, children: children }));
export default memo(TextElement);
